

























import Vue from 'vue';
import { WorkflowJobService } from '@/services/WorkflowJobService';
import { WorkflowJobTracingDataModel } from '@/types';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreFilter from '@/components/shared/MStoreFilter.vue';
import { WorkflowJobModel } from '@/types';
import { BTableHelpers } from '@/mixins/bTable';

export default Vue.extend({
  name: 'WorkflowJobTracingTab',
  data() {
    return {
      workflowJobTracingData: {} as WorkflowJobTracingDataModel,
      isLoading: false,
      searchQuery: '',
      emptytext: 'No Records to show'
    };
  },
  mixins: [BTableHelpers],
  props: {
    workflowJobModel: {
      type: Object as () => WorkflowJobModel,
      required: true
    }
  },
  methods: {
    async getWorkflowJobTracingAsync(this: any, jobId: number) {
      this.isLoading = true;
      try {
        await WorkflowJobService.getWorkflowJobTracingAsync(jobId).then((result: WorkflowJobTracingDataModel) => {
          this.workflowJobTracingData = result;
        });
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted() {
    this.getWorkflowJobTracingAsync(this.workflowJobModel.jobId);
  },
  components: {
    LoadingSpinner,
    MStoreFilter
  }
});
